var exports = {
  "Zg": "SoundboardEmoji.module__emoji___NkVrVk",
  "Qq": "SoundboardEmoji.module__text___NkVrVk",
  "Np": "SoundboardEmoji.module__fallback___NkVrVk",
};

module.exports = exports;
